export default "__VITE_ASSET__3a5f40dd__"